module.exports = __webpack_public_path__ + "img/mediagirl2_2022.4565df10.jpg";